import {
  Component,
  ElementRef,
  HostListener,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren,
  ViewEncapsulation,
} from "@angular/core";
import { ConductorVehiculoService } from "../../../../shared/services/conductor.service";
import { FormBuilder } from "@angular/forms";
import { NgbAccordion } from "@ng-bootstrap/ng-bootstrap";
import { NgSelectComponent } from "@ng-select/ng-select";
import { NgbdSortableHeader } from "../../../../shared/directives/NgbdSortableHeader";
import { ActivatedRoute } from "@angular/router";
import { Utils } from "../../../../shared/utils/Utils";
import jsPDF from "jspdf";
declare var require;
const Swal = require("sweetalert2");

@Component({
  selector: 'app-conductores',
  templateUrl: './conductores.component.html',
  styleUrls: ['./conductores.component.scss']
})
export class ConductoresComponent {

  @ViewChild("inputServicio") inputServicio!: ElementRef;
  @ViewChild("inputPlaca") inputPlaca!: ElementRef;
  @ViewChild("inputInterno") inputInterno!: ElementRef;
  @ViewChild("inputEmpresa") inputEmpresa!: NgSelectComponent;
  @ViewChild("inputClase") inputClase!: NgSelectComponent;
  @ViewChild("inputMarca") inputMarca!: NgSelectComponent;
  @ViewChild("inputModelo") inputModelo!: NgSelectComponent;
  @ViewChild("inputRelacion") inputRelacion!: NgSelectComponent;
  @ViewChild("inputPassword") inputPassword!: ElementRef;
  @ViewChild("accordion", { static: false }) accordion!: NgbAccordion;
  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;

public searchText: string = '';
  pageSize1: number = 10;
  page1: number = 1;
  totalItems: number;
  conductores: any;
  maxDate: string;
  minDate: string;
  sortColumn: string = '';
  sortDirection: 'asc' | 'desc' = 'asc';
  filteredTableItems: ConductorVehiculoService[];

  constructor(
    private conductorService: ConductorVehiculoService,
    private fb: FormBuilder,
    private route: ActivatedRoute
  ) { }


  ngOnInit() {
    this.listarConductor();
  }

  listarConductor(): void {
    this.conductorService.getAllConductorVehiculo().subscribe({
      next: (data) => {
        this.conductores = data; // <-- mejor en plural y claro
         this.filteredTableItems =this.conductores // ✅ Inicializa la tabla filtrada
      },
      error: (err) => console.error("Error cargando vehículos con conductor", err)
    });
  }

  exportToPDF(tableId: string, nameFile: string, titleFile: string) {
    Utils.exportToPDF(tableId, nameFile, titleFile);
  }

  exportarExcel(tableId: string, nameFile: string) {
    Utils.exportVisibleTableToExcel(tableId, nameFile);
  }

  ngOnDestroy() {
    //  this.algunObservable.unsubscribe();
  }
  sortData(column: string) {
  if (this.sortColumn === column) {
    this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
  } else {
    this.sortColumn = column;
    this.sortDirection = 'asc';
  }

  const listToSort = this.filteredTableItems.length ? this.filteredTableItems : this.conductores;

  listToSort.sort((a, b) => {
    let aVal = this.getFieldValue(a, column);
    let bVal = this.getFieldValue(b, column);

    if (typeof aVal === 'string') aVal = aVal.toLowerCase();
    if (typeof bVal === 'string') bVal = bVal.toLowerCase();

    if (aVal < bVal) return this.sortDirection === 'asc' ? -1 : 1;
    if (aVal > bVal) return this.sortDirection === 'asc' ? 1 : -1;
    return 0;
  });

  // Solo para reiniciar la paginación
  this.page1 = 1;
}


getFieldValue(item: any, column: string): any {
  switch (column) {
    case 'vehiculo_id':
      return item.vehiculo_id;
    case 'conductor_id':
      return item.conductor_id;
    case 'nombre':
      return `${item.propietario?.primernombre || ''} ${item.propietario?.segundonombre || ''} ${item.propietario?.papellidos || ''} ${item.propietario?.seapellidos || ''}`;
    default:
      return '';
  }
}
filterData() {
  const search = this.searchText.toLowerCase().trim();
  console.log(search);

  this.filteredTableItems = this.conductores.filter(conductor => {
    const values = [
      conductor.vehiculo_id,
      conductor.conductor_id,
      conductor.propietario?.primernombre,
      conductor.propietario?.segundonombre,
      conductor.propietario?.papellidos,
      conductor.propietario?.seapellidos
    ];

    const combined = values
      .map(val => (val ? val.toString().toLowerCase() : ''))
      .join(' ');

    return combined.includes(search);
  });

  this.page1 = 1; // Reinicia a la primera página
}
}